import { ApplicationCount } from '@features/applications';
import { Typography, Tooltip } from '@mui/material';
import { Position } from '@staffedupusa/shared-components';
import React from 'react';

function StaffLevelCopy({
  position,
  applicationCount,
  isJobPage,
}: {
  position?: Position;
  applicationCount?: ApplicationCount;
  isJobPage?: boolean;
}) {
  const { current_staff_count, desired_staff_count } = applicationCount
    ? applicationCount
    : position?.staff_count ?? {
        current_staff_count: 0,
        desired_staff_count: 0,
      };
  const currentStaff = Number(current_staff_count);
  const desiredStaff = Number(desired_staff_count);
  const fullyStaffed = desiredStaff > 0 && currentStaff > 0;

  if (isJobPage) {
    if (currentStaff === 0 && desiredStaff === 0) {
      return (
        <Tooltip
          arrow
          placement="right"
          title="Add a team par level for this position to keep track of your hiring efficiency and automate your hiring processes."
        >
          <Typography color="error.main">Staff levels not set</Typography>
        </Tooltip>
      );
    }

    if (fullyStaffed) {
      if (currentStaff === desiredStaff) {
        return <Typography color="success.main">100% Staffed</Typography>;
      } else if (currentStaff > desiredStaff) {
        return <Typography color="success.main">+100% Staffed</Typography>;
      } else {
        return (
          <Typography color="yellow.main">
            {currentStaff}/{desiredStaff} Positions Filled
          </Typography>
        );
      }
    }
  }

  return (
    <Typography
      color={
        currentStaff === 0 && desiredStaff === 0
          ? 'error.main'
          : currentStaff === desiredStaff || currentStaff > desiredStaff
            ? 'success.main'
            : currentStaff < desiredStaff
              ? 'yellow.main'
              : 'text.secondary'
      }
      sx={{ whiteSpace: 'nowrap' }}
    >
      {desiredStaff === 0 && currentStaff === 0 && isJobPage
        ? 'Staff levels not set'
        : `${currentStaff}/${desiredStaff}`}
    </Typography>
  );
}

export default StaffLevelCopy;
